import Brosure1 from "../../media/carousel brosur ruko/brosure (1).png";
import Brosure2 from "../../media/carousel brosur ruko/brosure (2).png";
import Brosure3 from "../../media/carousel brosur ruko/brosure (3).png";
import Brosure4 from "../../media/carousel brosur ruko/brosure (4).png";
import Brosure5 from "../../media/carousel brosur ruko/brosure (5).png";
import Brosure6 from "../../media/carousel brosur ruko/brosure (6).png";
import Brosure7 from "../../media/carousel brosur ruko/brosure (7).png";
import Brosure8 from "../../media/carousel brosur ruko/brosure (8).png";

const brosureimages = [
  Brosure1,
  Brosure2,
  Brosure3,
  Brosure4,
  Brosure5,
  Brosure6,
  Brosure7,
  Brosure8,
];

export default brosureimages;
